module.exports = __webpack_public_path__ + "static/media/icon-bedroom-2.d8fcc696.svg";